var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 97,
    viewBox: "0 0 76 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8994 3V3C45.3183 3 47.6381 3.96134 49.348 5.67235L70.2932 26.6315C71.7599 28.0992 72.5838 30.0892 72.5838 32.1641V32.1641M42.8994 3H13.095C7.7958 3 3.5 7.29582 3.5 12.595V83.5978C3.5 88.8969 7.79582 93.1927 13.095 93.1927H62.9888C68.288 93.1927 72.5838 88.8969 72.5838 83.5978V32.1641M42.8994 3V22.5691C42.8994 27.8683 47.1952 32.1641 52.4943 32.1641H72.5838",
    stroke: "#292D32",
    strokeWidth: 5.75698
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4011 68.5987V50.0152H48.591V68.2456C48.591 69.1945 48.3097 70.122 47.7825 70.9109C47.2554 71.6999 46.5061 72.3148 45.6295 72.6779C44.7529 73.041 43.7882 73.136 42.8576 72.9509C41.927 72.7658 41.0722 72.3089 40.4012 71.6379C39.7303 70.967 39.2734 70.1122 39.0883 69.1816C38.9031 68.2509 38.9981 67.2863 39.3613 66.4097C39.7244 65.5331 40.3393 64.7838 41.1282 64.2566C41.9156 63.7305 42.8411 63.4492 43.788 63.4481C44.332 63.4551 44.8708 63.5546 45.3815 63.7423L46.6721 64.2167V62.8417V54.8126V53.8532H45.7126H32.2796H31.3201V54.8126V74.0026C31.3201 74.9514 31.0387 75.879 30.5116 76.6679C29.9844 77.4569 29.2352 78.0718 28.3585 78.4349C27.4819 78.798 26.5173 78.893 25.5867 78.7079C24.656 78.5228 23.8012 78.0659 23.1303 77.3949C22.4593 76.724 22.0024 75.8692 21.8173 74.9385C21.6322 74.0079 21.7272 73.0433 22.0903 72.1667C22.4534 71.29 23.0683 70.5408 23.8573 70.0136C24.6446 69.4875 25.5701 69.2062 26.517 69.2051C27.061 69.2121 27.5999 69.3116 28.1106 69.4993L29.4011 69.9737V68.5987Z",
    fill: "black",
    stroke: "#292D32",
    strokeWidth: 1.91899
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/audio-icon.a098a80f88eca6a9db0be05591815e5b.svg";
export { ForwardRef as ReactComponent };